import { Component, inject } from '@angular/core';
import { AuthUserService } from '@services/auth-user.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: false,
})
export class ConfirmDialogComponent {
  authUserService = inject(AuthUserService);
}
